import { deleteToken, getMessaging, getToken, isSupported, type Messaging } from "firebase/messaging";
import { app } from "./firebase";

// Generated once in the Firebase Console under Project Settings → Cloud
// Messaging → Web Push certificates. Public by design (it's embedded in the
// client bundle), unlike the server-side Admin SDK credentials used in
// functions/, which never leave the Cloud Functions runtime.
const VAPID_KEY = "BKzuXEoUxxKY9lHims4JiEz5OOZakeF2Hm5JtpQljE_IMZbtWYsy-GpNsnEFtR6ZAWOL5NVBSCIHx-YakTxXuVU";

const SW_SCOPE = "/firebase-cloud-messaging-push-scope";

let messagingPromise: Promise<Messaging | null> | null = null;

// Lazily resolved and cached: isSupported() does an async feature check
// (service worker + Notification API + IndexedDB), and Safari outside an
// installed PWA on iOS reports false — calling this anywhere just no-ops.
function getMessagingInstance(): Promise<Messaging | null> {
  if (!messagingPromise) {
    messagingPromise = isSupported().then((ok) => (ok ? getMessaging(app) : null));
  }
  return messagingPromise;
}

export function pushSupported(): Promise<boolean> {
  return getMessagingInstance().then((m) => m !== null);
}

// A dedicated, narrow scope (rather than "/") so this registration never
// competes with the PWA's own Workbox-generated service worker at the root
// scope — it only ever receives push events, nothing else.
async function registerPushServiceWorker(): Promise<ServiceWorkerRegistration> {
  return navigator.serviceWorker.register("/firebase-messaging-sw.js", { scope: SW_SCOPE });
}

export async function requestPushToken(): Promise<string | null> {
  const messaging = await getMessagingInstance();
  if (!messaging) return null;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  const registration = await registerPushServiceWorker();
  return getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: registration });
}

export async function revokePushToken(): Promise<void> {
  const messaging = await getMessagingInstance();
  if (!messaging) return;
  await deleteToken(messaging).catch(() => {});
}
